import { Box, Typography } from '@material-ui/core';
import { ApiResponse } from '@roc/feature-app-core';
import { VerticalBarLoader } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import { useDocumentLibraryStore } from '../hooks/useDocumentLibraryStore';
import { DocumentLibraryV3Service } from '../services/documentLibraryV3Service';
import { HtmlDocument } from './htmlDocument';

interface DocumentLibraryContentfulPageProps {
  documentId: string;
  contentId?: string;
}

export const DocumentLibraryContentfulPage = observer(
  ({ documentId, contentId }: DocumentLibraryContentfulPageProps) => {
    const { documentLibraryStoreNew } = useDocumentLibraryStore();
    const service = useMemo(() => new DocumentLibraryV3Service(), []);
    const [entryId, setEntryId] = useState<string>();
    const [failed, setFailed] = useState(false);

    useEffect(() => {
      let current = true;
      setEntryId(undefined);
      setFailed(false);
      service
        .getDocumentContent(documentId)
        .then((response: ApiResponse) => {
          if (!current) {
            return;
          }
          const page = response?.data?.data;
          const resolved = page?.contentfulContentId ?? contentId;
          if (resolved) {
            setEntryId(resolved);
          } else {
            setFailed(true);
          }
        })
        .catch(() => {
          if (current) {
            setFailed(true);
          }
        });
      return () => {
        current = false;
      };
    }, [documentId, contentId, service]);

    if (failed) {
      return (
        <Box p={4} textAlign="center">
          <Typography variant="body2" color="textSecondary">
            This page could not be loaded. Please try again.
          </Typography>
        </Box>
      );
    }

    if (!entryId) {
      return <VerticalBarLoader />;
    }

    return (
      <HtmlDocument
        key={entryId}
        contentId={entryId}
        documentLibraryStoreNew={documentLibraryStoreNew}
      />
    );
  }
);
